import PropTypes from 'prop-types';

import BearIcon from './icons/bear.svg';
import GallonIcon from './icons/gallon.svg';
import MooseIcon from './icons/moose.svg';
import {
  CardContainer,
  EnvironmentCard,
  EnvironmentContainer,
  EnvironmentSubtitle,
  EnvironmentTitle,
  TextPink,
} from './styles';
import { connectLocation } from '../../location/LocationConnectors';

const EnvironmentalImpact = connectLocation(({ results, t, locale }) => {
  const { savings } = results;
  const { bears, mooses, gasoline, poundsFiber, metricTonsFiber, tonsCO2 } = savings;
  const { code } = locale;

  return (
    <EnvironmentContainer>
      <EnvironmentTitle>{t('insulation.commercial.quietzone.environment.title')}</EnvironmentTitle>
      {code === 'fr-CA' ? (
        <EnvironmentSubtitle>
          L&apos;utilisation des matelas insonorisants ROSE NEXT GEN<sup>MC</sup> FIBERGLAS<sup>MD</sup> QUIÉTUDE
          <sup>MD</sup> pour réaliser votre prochain projet peut réduire l&apos;impact environnemental
        </EnvironmentSubtitle>
      ) : (
        <EnvironmentSubtitle>
          Using QuietZone® PINK NEXT GEN® FIBERGLAS® Acoustic Insulation in your next project may reduce the
          environmental impact
        </EnvironmentSubtitle>
      )}

      <CardContainer>
        <EnvironmentCard>
          <div>
            <p>{t('insulation.commercial.quietzone.environment.savings_of')}</p>
            <p>
              <TextPink>{poundsFiber}</TextPink>
            </p>
            <p>
              <strong>{t('insulation.commercial.quietzone.environment.pounds_fiber_1')}</strong>{' '}
              {t('insulation.commercial.quietzone.environment.pounds_fiber_2')}
              <sup>*</sup>
            </p>
          </div>
          <div>
            <p>
              <img src={BearIcon} alt="Bear Icon" />
            </p>
            <p>{t('insulation.commercial.quietzone.environment.equal_to')}</p>
            <p>
              <span>{bears}</span> {t('insulation.commercial.quietzone.environment.black_bears')}
              <sup>~</sup>
            </p>
          </div>
        </EnvironmentCard>
        <EnvironmentCard>
          <div>
            <p>{t('insulation.commercial.quietzone.environment.savings_of')}</p>
            <p>
              <TextPink>{metricTonsFiber}</TextPink>
            </p>
            <p>
              <strong>{t('insulation.commercial.quietzone.environment.metric_tons_1')}</strong>{' '}
              {t('insulation.commercial.quietzone.environment.metric_tons_2')}
              <sup>*</sup>
            </p>
          </div>
          <div>
            <p>
              <img src={MooseIcon} alt="Moose Icon" />
            </p>
            <p>{t('insulation.commercial.quietzone.environment.equal_to')}</p>
            <p>
              <span>{mooses}</span> {t('insulation.commercial.quietzone.environment.moose')}
              <sup>~</sup>
            </p>
          </div>
        </EnvironmentCard>
        <EnvironmentCard>
          <div>
            <p>
              {t('insulation.commercial.quietzone.environment.savings_of')}
              <span>{t('insulation.commercial.quietzone.results.up_to')}</span>
            </p>
            <p>
              <TextPink>{tonsCO2}</TextPink>
            </p>
            <p>
              <strong>
                {t('insulation.commercial.quietzone.environment.tons_co2')}
                <sub>2</sub>
              </strong>{' '}
              {t('insulation.commercial.quietzone.environment.emissions_avoided')}
              <sup>^‡</sup>
            </p>
          </div>
          <div>
            <p>
              <img src={GallonIcon} alt="Gallon Icon" />
            </p>
            <p>{t('insulation.commercial.quietzone.environment.equal_to')}</p>
            <p>
              <span>{gasoline}</span> {t('insulation.commercial.quietzone.environment.litres_gas')}
              <sup>†</sup>
            </p>
          </div>
        </EnvironmentCard>
      </CardContainer>
    </EnvironmentContainer>
  );
});

EnvironmentalImpact.propTypes = {
  results: PropTypes.shape({
    savings: PropTypes.shape({
      bears: PropTypes.number.isRequired,
      mooses: PropTypes.number.isRequired,
      gasoline: PropTypes.number.isRequired,
      poundsFiber: PropTypes.number.isRequired,
      metricTonsFiber: PropTypes.number.isRequired,
      tonsCO2: PropTypes.number.isRequired,
    }),
  }),
};

EnvironmentalImpact.defaultProps = {
  results: {
    savings: {
      bears: 0,
      mooses: 0,
      gasoline: 0,
      poundsFiber: 0,
      metricTonsFiber: 0,
      tonsCO2: 0,
    },
  },
};

export default EnvironmentalImpact;
